/* TWRD: skriftstedet paa varelinjen og paa anbefalings-kortet, ogsaa naar
 * markup'en er tegnet af JS.
 *
 * Varelinjen rendres i Liquid af snippets/cart-item.liquid, saa den er
 * rigtig med det samme fra serveren. Men temaets cart-components.js bruger
 * ikke Section Rendering: efter add, remove og antal bygger den linjen om
 * fra /cart.js, og den JSON har ingen produktbeskrivelse. Anbefalings-
 * kortene er paa samme maade en tom Liquid-skabelon der fyldes af JS.
 *
 * Referencerne kommer fra #twrd-verse-map, et opslag som Liquid rendrer
 * een gang i snippets/twrd-cart-drawer-v2.liquid. Der er kun een parser,
 * snippets/twrd-verse-ref.liquid, og der hentes intet ekstra.
 *
 * Produkter uden reference faar ingen node, og reserverer ingen plads.
 */
(function () {
  'use strict';

  var LINE_CLASS = 'twrd-line-verse';
  var REC_CLASS = 'twrd-rec-verse';
  var EMPTY = Object.create(null);
  var map = null;

  /* Opslaget huskes foerst naar det faktisk blev laest. Scriptet kan koere
     foer noden staar i DOM'en, og et tomt kort maa ikke laase sig fast for
     resten af sessionen. */
  function verses() {
    if (map) return map;
    var node = document.getElementById('twrd-verse-map');
    if (!node) return EMPTY;
    var table = Object.create(null);
    try {
      var parsed = JSON.parse(node.textContent || '{}');
      Object.keys(parsed).forEach(function (handle) {
        if (typeof parsed[handle] === 'string') table[handle] = parsed[handle];
      });
    } catch (e) {
      /* et daarligt opslag maa ikke braekke kurven */
      return EMPTY;
    }
    map = table;
    return map;
  }

  /* /products/<handle> fra elementets eget link. Intet opslag, intet kald. */
  function handleIn(el) {
    var link = el.querySelector('a[href*="/products/"]');
    var href = link && link.getAttribute('href');
    if (!href) return '';
    var match = href.split('?')[0].split('#')[0].match(/\/products\/([^/]+)/);
    return match ? match[1] : '';
  }

  /* Idempotent: een node, samme tekst, samme plads. Uden reference fjernes
     en node der maatte staa fra et tidligere produkt paa samme plads. */
  function place(parent, anchor, className, verse, tagName) {
    var node = parent.querySelector('.' + className);
    if (!verse) {
      if (node && node.parentNode) node.parentNode.removeChild(node);
      return;
    }
    if (!node) {
      node = document.createElement(tagName);
      node.className = className;
    }
    if (node.previousElementSibling !== anchor || node.parentNode !== parent) {
      parent.insertBefore(node, anchor ? anchor.nextSibling : parent.firstChild);
    }
    if (node.textContent !== verse) node.textContent = verse;
  }

  /* Varelinjen: under titlen, over meta-linjen. */
  function fillLines(table) {
    document.querySelectorAll('.cart__items cart-item').forEach(function (line) {
      var header = line.querySelector('.cart-item__header');
      if (!header) return;
      /* Titlens egen wrapper, altsaa foerste barn der ikke er verset selv. */
      var anchor = header.querySelector(':scope > :not(.' + LINE_CLASS + ')');
      place(header, anchor, LINE_CLASS, table[handleIn(line)], 'p');
    });
  }

  /* Anbefalings-kortet: under motivet. fixRecs i
     snippets/twrd-cart-drawer-v2.liquid laegger sin meta-linje efter denne
     node, saa raekkefoelgen bliver motiv / vers / meta som paa kortet. */
  function fillRecs(table) {
    document.querySelectorAll('.cart-recommendations .product-card--mini').forEach(function (card) {
      var details = card.querySelector('.product-card__details');
      var title = details && details.querySelector('.product-card__title');
      if (!details || !title) return;
      place(details, title, REC_CLASS, table[handleIn(card)], 'span');
    });
  }

  var observer = null;
  var scheduled = false;

  function observeCartRoots() {
    var roots = document.querySelectorAll('#modal-cart, .cart--page, #main-cart');
    for (var i = 0; i < roots.length; i += 1) {
      observer.observe(roots[i], { childList: true, subtree: true });
    }
  }

  function run() {
    if (observer) observer.disconnect();
    try {
      var table = verses();
      fillLines(table);
      fillRecs(table);
    } catch (e) {
      /* en enkelt daarlig linje maa ikke stoppe kurven */
    }
    if (observer) observeCartRoots();
  }

  /* Bevidst setTimeout og ikke requestAnimationFrame: en fane i baggrunden
     faar ingen frames, og saa ville opdateringen aldrig komme. */
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      run();
    }, 0);
  }

  function init() {
    observer = new MutationObserver(schedule);
    run();
    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('on:cart:loaded', schedule);
    document.addEventListener('twrd:cart-lines', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
